import {date} from '@eitje/utils'
import ActiveRecord from './active_record/base'

class BaseConnection extends ActiveRecord {
	static defaultJoins = ['integrationExtEnvironments']
	static tableName = 'integrationBaseConnections'

	hasExportOption(name) {
		if (!this.hasPush) return false
		const exp = this.export
		if (!exp || !exp.hide) return true
		return !exp.hide.includes(name)
	}

	exportHours(data) {
		return this.resourceReq('export_hours', {...data, method: 'POST'})
	}

	sync = async (_date = date().format()) => {
		const res = await this.resourceReq('sync', {date: _date})
		if (res.ok) {
			this.modelConfig?.onSyncSuccess?.(this, res)
		}
		return res
	}

	hasIssue() {
		return this.authIssue()
	}

	authIssue() {
		return this.last_sync_datetime && !this.authed
	}

	isHr() {
		return this.type == 'hr'
	}

	isPos() {
		return this.type == 'pos'
	}

	isLoyalty() {
		return this.type == 'loyalty'
	}

	exportUser(data) {
		return this.resourceReq('export_user', data)
	}

	hasSettings() {
		return this.sanitized_type == 'nmbrs'
	}

	baseLink = () => `/integrations/${this.sanitized_type}/${this.id}`
	makeLink = suffix => `${this.baseLink()}/${suffix}`

	exportHoursUrl = () => this.makeLink('export_hours')
	issuesUrl = () => this.makeLink('fix_provider_issues')
	reAuthUrl = () => `/integrations/${this.sanitized_type}/activate?connection_id=${this.id}`
	exportUsersUrl = () => `/integrations/fooks/${this.id}/export_users`
	syncHistoryUrl = () => this.makeLink('sync_history')

	setupUrl() {
		if (this.isLoyalty()) return this.makeLink('setup_base')
		const suffix = this.isHr() ? 'hr' : 'revenue'
		return this.makeLink(`setup_${suffix}`)
	}
}

export default BaseConnection
